import { useNavigate } from '@frontend/weave-router';
import { useCommonActionSubscriptions } from './actions/use-common-actions-subscriptions';
import { useNotificationActionSubscription } from './actions/use-notification-action-subscription';
import { useNotification } from './use-notification';

export const useFaxTagNotification = () => {
  const { create, remove } = useNotification<'fax-tag'>();
  const navigate = useNavigate();
  useCommonActionSubscriptions('fax-tag');

  useNotificationActionSubscription('fax-tag', 'view', ({ notification }) => {
    if (!notification.payload?.faxId) {
      return navigate({
        to: '/fax/$filter',
        params: { filter: 'inbox' },
        search: { isNotification: true },
      });
    }

    return navigate({
      to: '/fax/$filter/$faxId',
      params: { filter: 'inbox', faxId: notification.payload.faxId },
      search: {
        isNotification: true,
      },
    });
  });

  return {
    create,
    remove,
  };
};
